import { ClientOrderTrackingOrderFolder } from "@redotech/redo-views-common/folders";
import { ClientOrderTrackingOrderView } from "@redotech/redo-views-common/views";
import * as z from "zod";
import { null as zNull } from "zod";

export const getOrderTrackingOrderViewsAndFolders = {
  name: "getOrderTrackingOrderViewsAndFolders" as const,
  input: zNull(),
  output: z.object({
    folders: z.array(ClientOrderTrackingOrderFolder),
    views: z.array(ClientOrderTrackingOrderView),
  }),
};
